<template>
  <div class="full-container-page display-col full-height">
    <div class="lx-flex-shrink-0 lx-flex-row-between" v-if="showBreadCrumb=='1'&&canReturn=='0'">
      <BreadCrumb />
      <div style="margin-bottom:10px">
        <a target="_blank"
           href="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com/oytqc/instructions/%E8%A9%B3%E7%B4%B0%E6%A4%9C%E5%93%81%E6%8C%87%E7%A4%BA%E6%9B%B8.xlsx"
           style="margin-right:20px">{{$t('excel.excel14')}}</a>
        <a target="_blank"
          href="https://oytqc.oss-ap-northeast-1.aliyuncs.com/oytqc/instructions/%E3%82%A2%E3%83%AA%E3%83%91%E3%83%BC%E3%83%88%E3%83%8A%E3%83%BC%E3%82%BA%E7%99%BA%E6%B3%A8%E3%82%B7%E3%82%B9%E3%83%86%E3%83%A0%E4%BD%BF%E7%94%A8%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB.pdf"
          style="margin-right:20px">{{$t('excel.excel12')}}</a>
        <a target="_blank"
          href="https://docs.google.com/spreadsheets/d/1cXC1BUD-RYuISOKdMCJMSwhpZJJrff6nH9SAk3czB08/edit?gid=1857100660#gid=1857100660">{{$t('excel.excel13')}}</a>
      </div>
    </div>

    <div class="breadcrumb-container editBread-container" v-if="showBreadCrumb=='1'&&canReturn=='1'">
      <slot name="editBreadcrumb"></slot>
    </div>
    <div class="full-container lx-flex-grow-1" :class="{hidden: isHidden}">
      <slot name="full"></slot>
    </div>
    <div style="margin-top: 10px;" class="full-container lx-flex-grow-1" :class="{hidden: isHidden}">
      <slot name="full-two"></slot>
    </div>
  </div>
</template>

<script>
import BreadCrumb from './layout/components/breadCrumb'
export default {
  data () {
    return {

    }
  },
  components: { BreadCrumb },
  props: {
    canReturn: {
      default: '0'
    },
    showBreadCrumb: {
      default: '1'
    },
    isHidden: {
      type: Boolean,
      default: false
    }
  },
  methods: {

  },
  created () {
  }
};
</script>

<style lang="less" scoped>
a {
  color: black;
  text-decoration: none;
}
.full-container-page {
  overflow: auto;
}
.editBread-container {
  padding-bottom: 10px;
}
.full-container {
  // margin-top: 10px;
  padding: 10px;
  // overflow: hidden;
  background-color: #fff;
  border-radius: 5px;
}
.full-container.hidden {
  overflow: hidden;
}
.breadcrumb {
  display: flex;
  justify-content: space-between;
}
</style>
